import { sendGet } from "api/restUtil";
import React, { Fragment, useEffect, useRef, useState } from "react";
import { v4 as uuidv4 } from "uuid";


/**
 * 공통코드로 CheckBox 표시
 * @param {boolean} valNm value를 이름으로 할지 여부. true이면 option의 value, label이 모두 공통코드 명으로 설정
 * @returns 
 */
export default function CommonCodeCheckBox({ item, onChange, value, readOnly, grpCd }) {

	const [options, setOptions] = useState([]);
    
	useEffect(() => {
		sendGet("/api/cmn-cd/" + grpCd )
		.then(result => {
			let resultData = result.data;
			const selOptions = resultData.map((item) => {
				return {label: item.cdNm, value: item.cd };
			})
			setOptions(selOptions);
		});
	},[grpCd]);

    return (
       <div style={{display : "flex"}}>
            {options.map((op) => {
				const id = uuidv4();
				return (
                <Fragment key={id}>
					<input
						// key={id} // 각 요소에 고유한 키 추가
						id={id}
						//className="basic-input"
						type="checkbox"
						name={item.col || ""}
						value={op.value}
						// checked={selectedOption === value}
						checked = {value != null && value.includes(op.value)}
						onChange={onChange && ((e) => onChange(e))}
						disabled={readOnly || false}
						style={{marginLeft : "5px"}}
						// style={{marginLeft : "5px", marginRight : "5px"}}
					/>
					<label htmlFor={id}>{op.label}</label>
                </Fragment>
            )})}
        </div>
    );
}
